import { ReactNode } from 'react';

interface FormLabelProps {
  label: string;
  children: ReactNode;
  asRow?: boolean;
}

const FormLabel = ({ asRow, label, children }: FormLabelProps) => {
  return (
    <>
      <div className={`flex ${asRow ? 'flex-row items-center' : 'flex-col md:flex-row items-start gap-3 md:gap-7'}`}>
        <div className={`${asRow ? 'md:w-40' : 'w-72'} lg:w-90 text-white text-md leading-sm font-medium`}>{label}</div>
        {children}
      </div>
      {!asRow && <div className="h-px w-full my-2" />}
    </>
  );
};

export default FormLabel;
